import { CalendarHeart, HandHeart, UtensilsCrossed } from "lucide-react";
import { format } from "date-fns";
import { FAITHS } from "@/lib/lunelle-data";
import { DIET, seasonFor } from "@/lib/faith-customs";

const fmt = (d) => format(d, "d MMM");

export const SeasonNote = ({ faith, className = "" }) => {
  const s = seasonFor(faith);
  if (!s) return null;
  return (
    <div className={`rounded-2xl bg-[#2C221E] p-4 text-[#FBF5EE] ${className}`} data-testid="faith-season-note">
      <p className="flex items-center gap-2 text-[11px] font-semibold uppercase tracking-[0.18em] text-[#E8B99A]"><CalendarHeart className="h-3.5 w-3.5" />
        {s.active ? `${s.name} now · until ${fmt(s.end)}` : `${s.name} in ${s.daysUntil} days · ${fmt(s.start)}`}
      </p>
      <p className="mt-2 text-sm leading-relaxed text-[#F4DED3]">{s.tip}</p>
    </div>
  );
};

// Shown to signed-in members: how their plate follows their faith's customs
export const FaithTable = ({ faith }) => {
  const d = DIET[faith];
  const name = FAITHS.find((f) => f.id === faith)?.name;
  return (
    <div className="mt-6 space-y-3 rounded-3xl border border-[#C86D51]/20 bg-[#FDFBF7]/80 p-5" data-testid="faith-table-card">
      <p className="flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.2em] text-[#9E4429]"><UtensilsCrossed className="h-4 w-4" />
        Your {name} table · <span data-testid="faith-diet-label">{d.label}</span>
      </p>
      <p className="text-sm text-[#3D302B]" data-testid="faith-diet-note">{d.note}</p>
      <p className="flex items-start gap-2 font-serif text-lg italic text-[#5C4A42]" data-testid="faith-grace"><HandHeart className="mt-1 h-4 w-4 shrink-0 text-[#9E4429]" />{d.grace}</p>
      <SeasonNote faith={faith} />
    </div>
  );
};
